import { useRender } from '@base-ui/react/use-render'
import { cn } from '../../lib/cn'
import s from './VisuallyHidden.module.css'

/**
 * Texte **lu, jamais vu**. Rogné par `clip-path`, pas `display: none` : ce dernier le sortirait de
 * l'arbre d'accessibilité, et une région `aria-live` ainsi cachée resterait muette.
 */
export type VisuallyHiddenProps = useRender.ComponentProps<'span'>

export function VisuallyHidden({ render, className, ...props }: VisuallyHiddenProps) {
  return useRender({
    render,
    defaultTagName: 'span',
    props: { className: cn(s.root, className), ...props },
  })
}
